import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export class Accordions {
  constructor() {
    this.accordionElements = document.querySelectorAll(".accordion");
    this.init();
  }

  init() {
    this.accordionElements.forEach((accordion) => {
      this.setupAccordion(accordion);
    });

    this.checkUrlHash();
  }

  setupAccordion(accordion) {
    const accordionDrawers = accordion.querySelectorAll(".accordion-drawer");

    accordionDrawers.forEach((drawer) => {
      const drawerTitle = drawer.querySelector(".accordion-drawer__title");
      const drawerContent = drawer.querySelector(".accordion-drawer__content");
      const drawerPlus = drawer.querySelector(".accordion-drawer__title svg");
      const drawerPlusHorizontalLine = drawer.querySelector(
        ".accordion-drawer__title svg path:nth-child(1)"
      );

      if (!drawerTitle || !drawerContent) return;

      drawerTitle.addEventListener("click", (e) => {
        this.toggleDrawer(
          drawer,
          drawerTitle,
          drawerContent,
          drawerPlus,
          drawerPlusHorizontalLine
        );
      });
    });
  }

  toggleDrawer(
    drawer,
    drawerTitle,
    drawerContent,
    drawerPlus,
    drawerPlusHorizontalLine
  ) {
    const duration = this.getAnimationDuration();

    if (drawer.getAttribute("aria-expanded") === "true") {
      this.closeDrawer(
        drawer,
        drawerTitle,
        drawerContent,
        drawerPlus,
        drawerPlusHorizontalLine,
        duration
      );
    } else {
      this.openDrawer(
        drawer,
        drawerTitle,
        drawerContent,
        drawerPlus,
        drawerPlusHorizontalLine,
        duration
      );
    }
  }

  closeDrawer(
    drawer,
    drawerTitle,
    drawerContent,
    drawerPlus,
    drawerPlusHorizontalLine,
    duration
  ) {
    gsap
      .timeline({
        defaults: { duration, ease: "power1.inOut" },
      })
      .to(drawerPlus, { rotate: 0, transformOrigin: "center center" })
      .to(
        drawerPlusHorizontalLine,
        { rotate: 0, transformOrigin: "center center" },
        "<"
      )
      .to(drawerContent, { height: 0, autoAlpha: 0 }, "<");

    drawer.setAttribute("aria-expanded", "false");
    drawerTitle.setAttribute("aria-expanded", "false");
    history.replaceState(null, null, " ");
  }

  openDrawer(
    drawer,
    drawerTitle,
    drawerContent,
    drawerPlus,
    drawerPlusHorizontalLine,
    duration
  ) {
    gsap
      .timeline({
        defaults: { duration, ease: "power1.inOut" },
      })
      .to(drawerPlus, { rotate: 90, transformOrigin: "center center" })
      .to(
        drawerPlusHorizontalLine,
        { rotate: 90, transformOrigin: "center center" },
        "<"
      )
      .to(drawerContent, { height: "auto", autoAlpha: 1 }, "<");

    drawer.setAttribute("aria-expanded", "true");
    drawerTitle.setAttribute("aria-expanded", "true");
    history.replaceState(null, null, `#${drawer.id}`);
  }

  getAnimationDuration() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? 0
      : 0.5;
  }

  checkUrlHash() {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      const drawer = document.querySelector(".accordion__drawer#" + hash);

      if (drawer) {
        const drawerTitle = drawer.querySelector(".accordion-drawer__title");
        if (drawerTitle) {
          drawerTitle.dispatchEvent(new Event("click"));

          const duration = this.getAnimationDuration();
          gsap.to(window, {
            duration,
            scrollTo: {
              y: drawer,
              offsetY: gsap.getProperty("html", "scroll-padding-top"),
            },
            ease: "power1.inOut",
          });
        }
      }
    }
  }
}
